import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalVariable } from './_helpers/localvariable'
import { IsInfo } from './_helpers/isInfo'
import {ChangeDetectorRef} from '@angular/core'
import { ActivatedRoute } from "@angular/router";
import { DashboardService } from './dashboard/dashboard.service';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  prenium = "../assets/images/prenium.png";
  notprenium = "../assets/images/notprenium.png";
  resultConfirmEmail;
  resultSubscribeEmail;
  typeAction;
  version;

  constructor(private router: Router, private ref: ChangeDetectorRef, public isInfo: IsInfo,private route: ActivatedRoute, private dashboardService : DashboardService, private titleService: Title) {
    this.titleService.setTitle("VirtualRacesFrance"); 
    this.isInfo.checkInfo();
    this.checkParam();
    if(!environment.production){
      this.version = environment.version;
    }
  }


  async checkParam(){

    let id;
    let token;
    let mail;
    let type;

    this.route.queryParams.subscribe(async(params) => {

      if(params['id'] && params['token']){
        id = params['id'];
        token = params['token'];
        mail = params['mail']
        type = params['type'];
      }else{
        id = null;
        token = null;
        mail = null;
        type = null;
      }

      switch(type){
        case "mailparam":
          this.resultSubscribeEmail = await this.dashboardService.mailParam(id, token, mail);
          break;
        case "confirm":
          this.resultConfirmEmail = await this.dashboardService.verifyEmail(id, token);
          break;
      }

      this.typeAction = type;

    });


  }
  
  logOut(){
    LocalVariable.logOut(this.router);
    this.ref.detectChanges();
  }




  
}
